import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Layout, Result } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;

// status -> Result content. Falls back to a generic success message when no
// status param is present, so this page still works as a plain link target.
const STATUS_CONTENT = {
  success: (inventoryNumber) => ({
    status: 'success',
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    title: 'Response Recorded',
    subTitle: inventoryNumber
      ? `Thanks! Inventory number ${inventoryNumber} confirmed.`
      : 'Thanks! Your response has been confirmed.',
  }),
  invalid: () => ({
    status: 'warning',
    icon: <CloseCircleOutlined style={{ color: '#faad14' }} />,
    title: 'Link Invalid',
    subTitle: 'This link is invalid or has already been used.',
  }),
  expired: () => ({
    status: 'warning',
    icon: <ClockCircleOutlined style={{ color: '#faad14' }} />,
    title: 'Link Expired',
    subTitle: 'This link has expired — ask an admin to resend it.',
  }),
  error: () => ({
    status: 'error',
    icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
    title: 'Something Went Wrong',
    subTitle: 'Something went wrong on our end — please try again later.',
  }),
};

const ResponseRecorded = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const inventoryNumber = searchParams.get('inventoryNumber');

  const content = (STATUS_CONTENT[status] || STATUS_CONTENT.success)(inventoryNumber);

  return (
    <Layout style={{ minHeight: '100vh', background: '#fafafa' }}>
      <Header style={{
        padding: '12px 16px',
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        height: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}>
          <img
            src="/images/FM_Logo.png"
            alt="Festivals Malta"
            onClick={() => navigate('/')}
            style={{
              height: '36px',
              width: 'auto',
              maxWidth: '160px',
              cursor: 'pointer',
              objectFit: 'contain',
            }}
          />
        </div>
      </Header>

      <Content style={{
        padding: '48px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 64px)'
      }}>
        <Result
          icon={content.icon}
          title={content.title}
          subTitle={content.subTitle}
          style={{
            background: '#fff',
            padding: '48px 24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        />
      </Content>
    </Layout>
  );
};

export default ResponseRecorded;
